import { ICliJob } from 'cliOld/types';
import { mapRecordFromServer, mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import {
  GetManyCountResponse,
  GetManyResponse,
  GetOneResponse,
  IRequestPayload,
} from 'coreOld/types';
import {
  getFormData,
  getQueryString,
  objectKeysCamelToSnakeCase,
  objectKeysSnakeCaseToCamelCase,
} from 'coreOld/utils';
import { ICompanyPart } from 'partsOld/types';

export const getMany = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ICompanyPart>> => {
  const { data } = await partfinitiClient.get(
    `/corporate_v2/part/parts?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`,
    signal
  );

  return mapRecordsFromServer<ICompanyPart>(data.data, data.recordsFiltered);
};

export const getManyCount = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyCountResponse> => {
  const { data } = await partfinitiClient.get(
    `/corporate_v2/part/count?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`,
    signal
  );

  return { count: data.corporatePartsCount };
};

export const getOne = async (params): Promise<GetOneResponse<Partial<ICompanyPart>>> => {
  const { data } = await partfinitiClient.get(
    `/corporate_v2/part/get-details?${getQueryString(objectKeysCamelToSnakeCase(params))}`
  );

  return mapRecordFromServer<ICompanyPart>(data.corporate_part);
};

export const upsertCompanyPart = async (data) => {
  const dataToSend = getFormData({
    corporate_part: objectKeysCamelToSnakeCase(data),
  });

  const { data: record } = await partfinitiClient.post('/corporate/parts/save', dataToSend);

  return objectKeysSnakeCaseToCamelCase(record.corporate_part);
};

export const exportCompanyParts = async (data): Promise<ICliJob> => {
  const dataToSend = getFormData({
    options: objectKeysCamelToSnakeCase(data),
  });

  const { data: record } = await partfinitiClient.post(
    '/corporate_v2/part/start-generating-part-export-file',
    dataToSend
  );

  return objectKeysSnakeCaseToCamelCase(record.cli_job);
};

export const removeBulk = async (data) => {
  const dataToSend = getFormData(data);

  return partfinitiClient.post('/corporate_v2/part/remove-bulk', dataToSend);
};

export const addCostNote = async (data) => {
  const dataToSend = getFormData(objectKeysCamelToSnakeCase(data));

  return partfinitiClient.post('/corporate_v2/part/add-notes-to-parts', dataToSend);
};

export const removeCostNote = async (data) => {
  const dataToSend = getFormData(objectKeysCamelToSnakeCase(data));

  return partfinitiClient.post('/corporate_v2/part-note-edit/remove-bulk', dataToSend);
};

export const editCostNote = async (data) => {
  const dataToSend = getFormData(objectKeysCamelToSnakeCase({ corporatePartNote: data }));

  const { data: record } = await partfinitiClient.post(
    '/corporate_v2/part-note-edit/save',
    dataToSend
  );

  return objectKeysSnakeCaseToCamelCase(record.corporate_part_note);
};
